import { ReactNode, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { AppBar } from "@mui/material";
import { useImperativeModal } from "ImperativeModalProvider";
import { QuestionMark } from "components/QuestionMark";
import { Box, DefaultModal, Toolbar } from "./CenterAlignedTAB.styled";

type CenterAlignedTABProps = {
  trailingButton: null | ReactNode;
  title: null | ReactNode;
  leadingButton: null | ReactNode;
  customer?: any;
};

export function CenterAlignedTAB({
  leadingButton,
  title,
  trailingButton = null,
  customer,
}: CenterAlignedTABProps) {
  const location = useLocation();
  const imperativeModal = useImperativeModal();

  const isPenchartPage = useMemo(() => {
    const { pathname, search } = location;
    return (
      pathname === "/pencharts" || decodeURIComponent(search).includes("펜차트")
    );
  }, [location]);

  const handleOpen = async () => {
    await imperativeModal.open((close) => (
      <DefaultModal
        open={true}
        title="이미지 등록 안내"
        body={
          <Box className="penchart-guide-text">
            <span>jpg, png 파일만 등록할 수 있습니다.</span>
            <span>
              이미지 파일 크기가 50MB를 초과하거나, 가로 또는 세로 길이가
              4096px을 초과하는 경우에는 앱에서 업로드 할 수 없으며 PC에서
              업로드해 주시길 바랍니다.
              <br />
              (안드로이드 기기는 4128px까지 가능)
            </span>
          </Box>
        }
        onClose={close}
      />
    ));
  };

  return (
    <AppBar
      position="sticky"
      color="inherit"
      sx={{
        boxShadow: "none",
        textAlign: "space-between",
      }}
    >
      <Toolbar>
        <Box className={`left-btn-wrapper ${customer ? "customer" : ""}`}>
          {leadingButton}
        </Box>
        <Box className={`title ${customer ? "customer" : ""}`}>{title}</Box>
        {trailingButton && (
          <Box className={`right-btn-wrapper ${customer ? "customer" : ""}`}>
            {trailingButton}
          </Box>
        )}
        {isPenchartPage && (
          <Box
            className={`guide-text ${
              location.pathname === "/pencharts"
                ? "absolute pos-right r-21"
                : ""
            }`}
            onClick={handleOpen}
          >
            이미지 등록 안내
            <QuestionMark size="medium" />
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
